<template>
  <ValidationObserver ref="observer">
    <ValidationProvider
      name="phone"
      ref="phoneProvider"
      rules="required|max:45"
      v-slot="{ errors }"
    >
      <v-text-field
        :error-messages="errors"
        :messages="['Ваш основной телефон']"
        class="mr-md-3 asd"
        label="Телефон"
        :prepend-icon="icons.mdiPhone"
        name="phone"
        type="text"
        v-model="phone"
      ></v-text-field>
    </ValidationProvider>
    <ValidationProvider
      name="phone_additional"
      ref="phoneAdditionalProvider"
      rules="max:45"
      v-slot="{ errors }"
    >
      <v-text-field
        :error-messages="errors"
        :messages="['Телефон вашего родителя, родственника или доверенного лица']"
        class="mr-md-3"
        label="Дополнительный телефон"
        :prepend-icon="icons.mdiPhone"
        name="phone_additional"
        type="text"
        v-model="phone_additional"
      ></v-text-field>
    </ValidationProvider>
  </ValidationObserver>
</template>

<script>
  import {mapGetters} from "vuex";
  import {mdiPhone} from '@mdi/js'
  import {extend, localize, ValidationObserver, ValidationProvider} from "vee-validate";
  import {max, required} from "vee-validate/dist/rules";

  export default {
    name: "ContactsForm",
    components: {
      ValidationProvider,
      ValidationObserver
    },
    props: ['step'],
    data() {
      return {
        icons: {
          mdiPhone,
        },
        isSuccess: false,
        phone: '',
        phone_additional: '',
      }
    },
    mounted() {
      this.$store.dispatch("abiturient/loadAbiturient")
        .then(() => {
          this.phone = this.abiturient.phone
          this.phone_additional = this.abiturient.phone_additional
        })
    },

    computed: {
      ...mapGetters("abiturient", ["abiturient"]),
      ...mapGetters("context", [
        'isLoading',
        'messages',
      ])
    },
    watch: {
      phone(value) {
        this.$store.commit("abiturient/UPDATE_ABITURIENT_MODEL", {phone: value})
      },
      phone_additional(value) {
        this.$store.commit("abiturient/UPDATE_ABITURIENT_MODEL", {phone_additional: value})
      },
    },
    methods: {
      async submit() {
        const valid = await this.$refs.observer.validate()

        if (valid) {
          this.$store.commit("context/CLEAR_MESSAGES");
          await this.$store.dispatch("abiturient/update")
            .then(() => {
              if (this.messages) {
                this.$refs.observer.setErrors(this.messages);
              } else {
                this.isSuccess = true
              }
            })
        }
      },
    }
  }

  localize({
    ru: {
      names: {
        phone: ' ',
        phone_additional: ' ',
      }
    }
  });
  extend('required', {
    ...required
  });
  extend('max', {
    ...max
  });

</script>
